// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2t50y","left":"styles_left__3tV49","desktopActions":"styles_desktopActions__zuy6B","title":"styles_title__2_YzE"};